var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-address-list',{attrs:{"list":_vm.list,"default-tag-text":_vm.$t('common.default'),"add-button-text":_vm.$t('address.add')},on:{"add":_vm.onAdd,"edit":_vm.onEdit,"select":_vm.selectLogisticsCompany},model:{value:(_vm.chosenCompanyId),callback:function ($$v) {_vm.chosenCompanyId=$$v},expression:"chosenCompanyId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }